var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"room-info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.roomInfo.name))]),_vm._v(" "),_c('div',{staticClass:"id"},[_vm._v("ID:"+_vm._s(_vm.roomUidName))])])}
var staticRenderFns = []

export { render, staticRenderFns }